import { ConfirmAccountScreen } from "@/features/auth/screens/ConfirmAccountScreen";
import {
    confirmAccountRouteSearchSchema,
    type ConfirmAccountRouteSearch,
} from "@/features/auth/search/authRouteSearch";
import { useAuth } from "@/utils/auth";
import { createFileRoute, Navigate } from "@tanstack/react-router";

const ConfirmAccountPage = () => {
    const { email, phone, invited_by_name, contactMethod, method } = Route.useSearch() as ConfirmAccountRouteSearch;
    const auth = useAuth();

    if (auth.isAuthenticated) {
        return <Navigate to="/change-password" />;
    }

    return (
        <ConfirmAccountScreen
            email={email}
            phone={phone}
            invitedByName={invited_by_name}
            contactMethod={contactMethod}
            method={method}
        />
    );
};

export const Route = createFileRoute("/_auth/confirm-account/")({
    component: ConfirmAccountPage,
    validateSearch: (search) => confirmAccountRouteSearchSchema.parse(search),
});
